import { UM_EXPORT_DEFAULT_CHECKED, UM_EXPORT_TREE, UM_LAYER_CATALOG } from '../_components';
import type { ExportTreeNode } from './types';

/**
 * Arbre "Autres couches" de l'export GeoJSON, construit à partir du menu Couches
 * (UM_LAYER_CATALOG = source de vérité pour les groupes et leur ordre).
 * Le contenu de chaque groupe a été relevé sur tests.urbanmap.myengie.com (menu Couches, 2026-10-15).
 */

/** Groupes du menu Couches qui ne sont pas des couches exportables ici. */
const EXCLUDED_GROUPS = ['buildings', 'my-selections'];

/** Couches de chaque groupe, relevées en production (menu Couches tout déplié). */
const GROUP_LAYERS: Record<string, string[]> = {
  'energy-networks': [
    'Canalisations RCU/RFU',
    'Réseau GRDF',
    'Réseau ENEDIS',
    'Zones de classement RCU/RFU',
    'Réseaux en construction',
    'Zones de réseaux en construction',
    'Périmètre contrat (DSP)',
    'Postes de livraison',
    'Centrales',
  ],
  consumption: ['PDL DLE ENEDIS', 'PDL DLE GRDF', 'PDL DLE Réseaux chaud et froid'],
  'energy-potential': [
    "Stations d'épuration",
    'ICPE',
    'UVE',
    'Datacenters',
    'Entrepôts frigorifiques',
    'Géothermies sur sonde',
    'Cheminées',
    'Groupes froids / dry coolers',
  ],
  regulatory: ['Quartiers prioritaires', 'Zones archéologiques (présomption)'],
  territorial: ['Contours administratifs', 'Parcelles', 'Routes'],
  climate: ['Zones climatiques'],
};

/** Groupes dépliés à l'ouverture (maquette). */
export const EXPANDED_LAYER_GROUPS = ['energy-networks', 'consumption'];

const slug = (s: string) =>
  s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const OTHER_LAYERS_ROOT = 'other-layers';
export const groupNodeId = (groupId: string) => `group:${groupId}`;

export const OTHER_LAYERS_TREE: ExportTreeNode = {
  id: OTHER_LAYERS_ROOT,
  label: 'Autres couches',
  children: UM_LAYER_CATALOG.filter((g) => !EXCLUDED_GROUPS.includes(g.id)).map((group) => {
    const labels = GROUP_LAYERS[group.id] ?? group.legend?.filter((item) => !item.sub).map((item) => item.label) ?? [];
    return {
      id: groupNodeId(group.id),
      label: group.label,
      children: labels.map((label) => ({ id: `layer:${group.id}:${slug(label)}`, label })),
    };
  }),
};

export const BUILDING_TREE: ExportTreeNode[] = UM_EXPORT_TREE;
export const BUILDING_DEFAULT_CHECKED: string[] = UM_EXPORT_DEFAULT_CHECKED;

export function leafIds(node: ExportTreeNode): string[] {
  return node.children?.length ? node.children.flatMap(leafIds) : [node.id];
}

export function findNode(nodes: ExportTreeNode[], id: string): ExportTreeNode | undefined {
  for (const n of nodes) {
    if (n.id === id) return n;
    const found = n.children && findNode(n.children, id);
    if (found) return found;
  }
  return undefined;
}

export const OTHER_LAYER_IDS = leafIds(OTHER_LAYERS_TREE);
